<template>
    <div>
        <Overlay v-if="this.loading"></Overlay>
        <Loading v-if="this.loading"></Loading>
        <div class="card-header">
            <div class="row">
                <div class="col-sm-6 text-left mb-3">
                    <h2 class="card-title">Add new board</h2>
                </div>
            </div>
        </div>
        <form @submit="addBoard" action="#">
            <div class="card-body mt-3">
                <transition
                        enter-active-class="animated fadeIn faster"
                        leave-active-class="animated fadeOut faster"
                >
                    <div class="alert alert-success" v-if="hasMessage">{{ message }}</div>
                </transition>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>Board name</label>
                            <input required type="text" v-model="boardName" class="form-control" placeholder="Board Name...">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>Board icon</label>
                            <input required type="text" v-model="boardIcon" class="form-control" placeholder="Board Icon...">
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <button type="submit" class="btn btn-fill btn-success">Add</button>
            </div>
        </form>
    </div>
</template>

<script>
    import axios from 'axios';
    import ApiService from "../../common/api.service";
    import Overlay from "../Overlay";
    import Loading from "../Loading";

    export default {
        name: "AdminNewBoard",
        components: {
            Overlay,
            Loading
        },
        data(){
            return {
                boardName: '',
                boardIcon: '',
                gameId: '',
                loading: false,
                hasMessage: false,
                message: ''
            }
        },
        methods: {
            addBoard(e){
                this.loading = true;
                let data = {
                    name: this.boardName,
                    icon: this.boardIcon,
                    game_id: this.gameId
                };
                axios.post(ApiService.getAction('admin', 'createBoard'), data).then( (response) => {
                    this.message = response.data.status ? 'Board created. ID: '+response.data.id : 'An error occurred';
                    this.animated = true;
                    this.hasMessage = true;
                }).finally(() => this.loading = false);

                e.preventDefault();
            }
        }
    }
</script>

<style scoped>

</style>
